import React from 'react';

const RegionRow = ({filter, conditionsList, regions, updateCondition, updateValue}) => {

  return (
    <span>
      <select value={filter.condition} onChange={e=> updateCondition(e.target.value)}>
        {conditionsList.map((o, i) => <option key={i} value={o}>{o}</option>) }
      </select>&nbsp;
      { !['is empty', 'is not empty'].includes(filter.condition) &&
        <select value={filter.value} onChange={e=> updateValue(e.target.value)}>
          { regions.map((o, i) => <option key={i} value={o.id}>{o.name}</option>) }&nbsp;
        </select>
      }
    </span>
  )
}

export default RegionRow
